import React from "react";

import DataTable from "../../../DataTable";

import { PROPOSED_SELLS_ROWS_LIMIT } from "../../../../constants";
import useOutputReportStore from "../../../../store/OutputReport.store";
import {
  extractRowKeys,
  getOutputType,
} from "../../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../../utils/resources/dataTableCopy";

import "./ProposedSellsDataTable.scss";

const ProposedSellsDataTable = () => {
  let reportName = "Proposed Sells"; // Refer to corresponding API Key
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);

  if (!data || !types) {
    return null;
  }

  const { reportType, assetType } = getOutputType(data);

  const headerKey = assetType === "equity" ? "Ticker" : "CUSIP[1]";
  // TODO: Remove next block after API fix.
  if (!data[reportName] && data["Proposed Sell"]) {
    reportName = "Proposed Sell";
  }

  // Custom processing of rows labels
  // Limit rows to 13,
  // then Add new rows for Others and Total
  const extractedRows = extractRowKeys(reportName, data) || [];
  let rows = [];
  if (extractedRows.length > PROPOSED_SELLS_ROWS_LIMIT) {
    rows = [
      ...extractedRows.slice(0, PROPOSED_SELLS_ROWS_LIMIT),
      {
        label: `Others (${extractedRows.length - PROPOSED_SELLS_ROWS_LIMIT})`,
        key: "Others",
      },
    ];
  } else {
    rows = extractedRows;
  }

  // Custom processing of columns
  const columns = Object.entries(data[reportName] || {}).map((key) => {
    const reducedColumns = [
      "Cost Basis (USD)",
      "Units",
      "Market Value",
      "Market Value (USD)",
    ];

    let total;
    let others;

    if (reducedColumns.includes(key[0])) {
      const values = Object.values(key[1]);
      total = values.reduce((acc, curr) => acc + curr, 0);
      others = values
        .splice(PROPOSED_SELLS_ROWS_LIMIT)
        .reduce((acc, curr) => (isNaN(curr) ? acc : acc + curr), 0);
    }

    return {
      columnTitle: key[0],
      ...key[1],
      Total: total,
      Others: others,
    };
  });

  return (
    <DataTable
      reportType={reportType}
      name="proposedSells"
      variation="max"
      tableCaption={`${reportName} Data Table`}
      tableRowHeaderKey={headerKey}
      tableRowKeys={rows}
      tableColumns={columns}
      tableDataTypes={types?.[reportName]}
      formatCellDataBy="column"
      footnote={
        <>
          {dataTableCopy.unlessOtherwiseStated}
          <br />
          [1]{dataTableCopy.existingPortfolioInformation}
          <br />
          [2]{dataTableCopy.modelAndTransitionAnalysis}
        </>
      }
    />
  );
};

export default ProposedSellsDataTable;
